import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import TabLayout from "src/components/base/tab-layout";
import { Tab, TabMenu } from "src/components/base/tab-menu";
import Outlet from "src/components/base/outlet";

/**
 * The properties for {@link ExitNodeTabs}
 */
export type ExitNodeTabsProps = {};

/**
 * Tabs for the exit node view
 */
export default function ExitNodeTabs(props: ExitNodeTabsProps) {
    const [t] = useTranslation("admin-exit-nodes");

    return (
        <TabLayout
            heading={t("heading.exit-nodes")}
            headingDescription={t("description.exit-nodes")}
            tabs={
                <TabMenu>
                    <Tab href={"/a/exitnodes/approved"}>{t("heading.approved")}</Tab>
                    <Tab href={"/a/exitnodes/pending"}>{t("heading.pending")}</Tab>
                </TabMenu>
            }
        >
            <Outlet />
        </TabLayout>
    );
}

export const Route = createFileRoute("/_admin/a/exitnodes/_exitnodes")({
    component: ExitNodeTabs,
});
